import { loadState, saveState } from '../helpers/localStorage'
import { generateId } from './string'

export const sessionUtil = ({ sessionTimeoutMs = 1000 * 60 * 30 } = {}) => {
  let state = loadState() || {
    clientId: generateId(),
    sessionNumber: 0,
    sessionId: null,
    lastActivity: 0,
    pageviews: 0
  }

  if (!state.clientId) state.clientId = generateId()

  const startNewSession = () => {
    state.sessionNumber = state.sessionNumber + 1
    state.sessionId = generateId()
    state.lastActivity = Date.now()
    state.pageviews = 0
    saveState(state)
    return state
  }

  const persistCheckoutVariant = (variant) => {
    try {
      const existing = loadState() || state
      existing.variant = variant
      saveState(existing)
      state = Object.assign({}, state, existing)
    } catch (e) {
      console.warn('persistCheckoutVariant error', e)
    }
  }

  const isSessionActive = () => {
    const inactivity = Date.now() - state.lastActivity
    if (!state.sessionId || inactivity > sessionTimeoutMs) {
      startNewSession()
      return false
    } else {
      state.lastActivity = Date.now()
      saveState(state)
    }
    return true
  }

  const getClientId = () => {
    return state.clientId
  }

  const getSessionId = () => {
    isSessionActive()
    return state.sessionId
  }

  const getSessionNumber = () => {
    isSessionActive()
    return state.sessionNumber
  }

  const getCheckoutVariant = () => {
    const activeSession = isSessionActive()
    if (!activeSession) return null
    const st = loadState()
    return st?.variant || null
  }

  return {
    getClientId,
    getSessionId,
    getSessionNumber,
    persistCheckoutVariant,
    getCheckoutVariant
  }
}
